__turbopack_context__.v({
  "active": "styles-module__NwLkRW__active",
  "checkmark": "styles-module__NwLkRW__checkmark",
  "error": "styles-module__NwLkRW__error",
  "indicatorSeparator": "styles-module__NwLkRW__indicatorSeparator",
  "indicatorsContainer": "styles-module__NwLkRW__indicatorsContainer",
  "input": "styles-module__NwLkRW__input",
  "is-selected": "styles-module__NwLkRW__is-selected",
  "menu": "styles-module__NwLkRW__menu",
  "option": "styles-module__NwLkRW__option",
  "optionContent": "styles-module__NwLkRW__optionContent",
  "rotateIndicator": "styles-module__NwLkRW__rotateIndicator",
  "selectSimpleControl": "styles-module__NwLkRW__selectSimpleControl",
  "selectSimpleControlBasket": "styles-module__NwLkRW__selectSimpleControlBasket",
  "valueContainer": "styles-module__NwLkRW__valueContainer",
  "valueContainerBasket": "styles-module__NwLkRW__valueContainerBasket",
});
